import UsersPermissionsContainer from "../../../features/user/UsersPermissionsContainer";
import { DPTO_PERMISSIONS, hasPermission, PermissionId } from "../../../app/permissions";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";

interface DptoUsersListProps {
  schoolId: string;
  dptoId: string;
}

const DptoUsersList = ({ schoolId, dptoId }: DptoUsersListProps) => {
    const user = useSelector(selectUser);
    const perm: boolean = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId);
    return <UsersPermissionsContainer
        canGrantPermission={perm}
        targetId={dptoId}
        permissions={DPTO_PERMISSIONS}
        messages={{
        title: "Funcionários",
        empty: "Ninguém associado a este departamento.",
        }}
    />;
};

export default DptoUsersList;